
import { baseUrl } from "../../constants";
import { getDDCompCall } from "../../redux/actions/dropDown";
import { setFullLoad } from "../../redux/actions/common";

export default {
    "formTitle": "Add Location",
    "tableTitle": "Location List",
    "apiDetails": {
        startUp: (dispatch) => {
            dispatch(setFullLoad(true));
            const dropDownArr = [
                getDDCompCall,
            ];
            setTimeout(()=>{
                dispatch(setFullLoad(false));
            }, 500);
            dropDownArr.forEach((func,) => {
                    dispatch(func());
            });
        },
        list: {
            url: `${baseUrl}/api/mms/location/list`,
            payload: {
                "search": "",
                "offset": 0,
                "limit": 50,
                "sort": "DESC",
                "column": "id"
            }
        },
        add: `${baseUrl}/api/mms/location`,
        edit: `${baseUrl}/api/mms/location/edit`,
        delete: `${baseUrl}/api/mms/location/remove`
    },
    "tableCol": [
        {
            name: 'Company',
            selector: row => row.comp_id,
            sortable: true
        },
        {
            name: 'Location',
            selector: row => row.name,
            sortable: true
        },
        {
            name: 'Address',
            selector: row => row.address,
            sortable: true
        }
    ],
    "formData": [
        {
            "formType": "flex",
            "formFields": [
                {
                    type: 'select',
                    label: 'Company',
                    name: 'comp_id',
                    "options": []
                },
                {
                    type: 'text',
                    label: 'Location',
                    name: 'name'
                },
                {
                    type: 'textArea',
                    label: 'Address',
                    name: 'address'
                }
            ]
        }
    ],
    "mockData": [{
        "company": 1,
        "location": "dgdg"
    }]
}